<template>
  <div :class="['category-tabs', 'main-tabs', { 'locale-zh-CN': isZhLocale }]">
    <div class="tab-group">
      <div 
        v-for="tab in tabs" 
        :key="tab.value"
        :class="['tab-item', { active: activeTab === tab.value }]"
        @click="handleTabClick(tab.value)"
      >
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainCategoryTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    activeTab: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleTabClick(value) {
      this.$emit('tab-change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.category-tabs {
  margin-bottom: 20px;
  
  &.main-tabs {
    position: relative;
    flex: 1;
    min-width: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    
    .tab-group {
      display: flex;
      gap: 0;
      flex-wrap: nowrap;
      max-width: 100%;
      overflow-x: auto;
      
      .tab-item {
        min-width: auto;
        height: 36px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        background: #FFFFFF;
        cursor: pointer;
        transition: all 0.3s;
        border: none;
        position: relative;
        white-space: nowrap;
        flex-shrink: 0;
        
        &:first-child {
          border-radius: 4px 0 0 4px;
        }
        
        &:last-child {
          border-radius: 0 4px 4px 0;
        }
        
        &.active {
          background: #F5F4EB;
          color: #8C7B21;
          font-weight: 500;
          
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 15px;
            height: 2px;
            background: #A0903C;
          }
        }
        
        &:hover:not(.active) {
          background: #F8F8F8;
        }
      }
    }
  }

  &.locale-zh-CN.main-tabs .tab-group .tab-item {
    font-size: 18px;
  }
}
</style>

